<template>
  <div>
    <b-row class="align-items-baseline">
      <b-col class="col-lg-2 col-md-3 col-12">
        <b-form-group :label="$t('navbars.by_objects')">
          <v-select
            v-model="params.object_id"
            :options="getAllObjects"
            label="title"
            class="bg-white"
            :disabled="isNotFetched"
            :reduce="(object) => object.id"
            @input="refresh"
          />
        </b-form-group>
      </b-col>
      <b-col class="col-lg-2 col-md-3 col-12">
        <b-form-group :label="$t('sms.manager')">
          <v-select
            v-model="params.manager_id"
            :options="onFilter"
            label="first_name"
            :reduce="(user) => user.id"
            class="bg-white"
            :disabled="isNotFetched"
            @input="refresh"
          >
            <li slot="list-footer" class="pagination">
              <button
                :disabled="!getUsers.previous"
                @click="previousUsersGet()"
              >
                {{ $t('prev') }}
              </button>
              <button :disabled="!getUsers.next" @click="nextUsersGet()">
                {{ $t('next') }}
              </button>
            </li>
          </v-select>
        </b-form-group>
      </b-col>
      <b-col class="col-lg-2 col-md-3 col-12">
        <b-form-group :label="$t('reports.by_debts')">
          <v-select
            v-model="params.is_debt"
            :options="filterTypeOptions"
            label="title"
            class="bg-white"
            :disabled="isNotFetched"
            :reduce="(type) => type.id"
            @input="refresh"
          />
        </b-form-group>
      </b-col>
      <b-col class="col-lg-2 col-md-3 col-12">
        <b-form-group :label="$t('general.conclusion_of_the_contract_from_to')">
          <VueDataPicker
            v-model="dateFromTo"
            :disabled="isNotFetched"
            :other-props="{ 'is-range': true }"
            @input="refresh"
          />
        </b-form-group>
      </b-col>
      <b-col class="col-lg-2 col-md-3 col-12">
        <b-form-group :label="$t('reports.related_person')">
          <v-select
            v-model="params.related_person"
            :options="relatedPerson"
            :get-option-label="(el) => el[$i18n.locale]"
            class="bg-white"
            :disabled="isNotFetched"
            :reduce="(el) => el.uz"
            @input="refresh"
          />
        </b-form-group>
      </b-col>
      <b-col class="col-lg-2 col-md-3 col-12">
        <b-form-group :label="$t('reports.is_formed')">
          <v-select
            v-model="params.is_formed"
            :options="[
              {
                title: {
                  ru: 'Оформлено',
                  uz: 'Rasmiylashtirilgan',
                },
                value: true,
              },
              {
                title: {
                  ru: 'Не оформлено',
                  uz: 'Rasmiylashtirilmagan',
                },
                value: false,
              },
            ]"
            :get-option-label="(el) => el.title[$i18n.locale]"
            class="bg-white"
            :disabled="isNotFetched"
            :reduce="(el) => el.value"
            @input="refresh"
          />
        </b-form-group>
      </b-col>

      <b-col class="col-4 d-flex justify-content-end align-items-end h-100">
        <b-button
          v-if="params.object_id"
          variant="success"
          class=""
          @click="exportExcel(params.object_id)"
        >
          <feather-icon icon="ArrowUpIcon" />
          {{ $t('generals.export') }}
        </b-button>
      </b-col>
    </b-row>
    <div class="my-2 d-flex align-items-center justify-content-end">
      <b-button variant="primary" v-b-modal.fields-settings-modal>
        Настройки полей
      </b-button>
    </div>
    <b-overlay :show="isNotFetched">
      <b-table
        responsive=""
        :fields="
          toggleFields(
            checkCollector()
              ? fields
              : fields.filter(
                  (el) =>
                    el.key !== 'description' &&
                    el.key !== 'related_person' &&
                    el.key !== 'client_phone_number',
                ),
          )
        "
        :items="items"
        bordered
        :empty-text="$t('objects.no_data')"
        show-empty
        no-local-sorting
        sticky-header="700px"
        @sort-changed="sorting"
      >
        <template #head()="data">
          <span>{{ $t(data.label) }}</span>
        </template>
        <template #cell(index)="props">
          <span v-if="props.item.name !== 'total'">
            {{ props.index + 1 }}
          </span>
          <h4 v-else class="font-weight-bold text-uppercase">
            Итог
          </h4>
        </template>
        <template #cell(total_price)="props">
          {{ $_moneyFormatter(props.item.total_price) }}
        </template>
        <template #cell(payment_sum)="props">
          {{ $_moneyFormatter(props.item.payment_sum) }}
        </template>
        <template #cell(monthly_price)="props">
          <b>{{ $_moneyFormatter(props.item.monthly_price) }}</b>
        </template>
        <template #cell(total_debt_sum_crm)="props">
          {{ $_moneyFormatter(props.item.total_debt_sum_crm) }}
        </template>
        <template #cell(total_debt_sum_bank)="props">
          {{ $_moneyFormatter(props.item.total_debt_sum_bank) }}
        </template>
        <template #cell(kv_m_price)="props">
          {{ $_moneyFormatter(props.item.kv_m_price) }}
        </template>
        <template #cell(expired_payment)="props">
          {{ $_moneyFormatter(props.item.expired_payment) }}
        </template>
        <template #cell(total_debt_sum)="props">
          {{ $_moneyFormatter(props.item.total_debt_sum) }}
        </template>
        <template #cell(created_at)="props">
          <span v-if="props.item.created_at" style="white-space: nowrap">
            {{ props.item.created_at }}
          </span>
        </template>
        <template #cell(related_person)="props">
          <div style="width: 150px;">
            <v-select
              v-if="props.item.name !== 'total'"
              v-model="props.item.related_person"
              :options="relatedPerson"
              :get-option-label="(el) => el[$i18n.locale]"
              class="bg-white"
              @input="changeRelatedPerson($event, props.item.id)"
            />
          </div>
        </template>
        <template #cell(description)="props">
          <div style="width: 250px;">
            <b-form-textarea
              v-model="props.value"
              @input="saveDescription($event, props.item.id)"
            />
          </div>
        </template>
        <template #cell(is_formed)="props">
          <div v-if="props.item.is_formed">
            {{ props.item.is_formed[$i18n.locale] }}
          </div>
        </template>
        <template #cell(actions)="props">
          <div
            v-if="props.item.name !== 'total'"
            class="d-flex justify-content-around"
          >
            <b-button
              v-b-modal.auto-sms-modal
              variant="success"
              size="sm"
              class="mr-1"
              @click="$router.push(`/clients/${props.item.client_id}`)"
            >
              <feather-icon icon="ChevronsRightIcon" />
            </b-button>
            <b-button
              variant="warning"
              size="sm"
              @click="() => $router.push('/finance')"
            >
              <feather-icon icon="DollarSignIcon" />
            </b-button>
          </div>
        </template>
      </b-table>
    </b-overlay>

    <div
      class="d-flex justify-content-between align-items-center flex-wrap mb-75 bg-white p-1"
    >
      <div class="d-flex align-items-center mb-0">
        <span class="text-nowrap text-black ml-1">
          {{ $t('generals.show_from') }}
        </span>
        <b-form-select
          v-model="params.page_size"
          :options="['10', '30', '100', { text: 'Все', value: 100000 }]"
          class="mx-1 text-black"
          @input="refresh"
        />
        <!-- <span class="text-nowrap text-black"> {{$t('pagination.entries')}} </span> -->
      </div>
      <div class="mb-1">
        <b-pagination
          v-model="params.page"
          :total-rows="totalCount"
          :per-page="params.page_size"
          first-number
          last-number
          align="right"
          prev-class="prev-item"
          next-class="next-item"
          class="mt-1 mb-0"
          @input="changePagination"
        >
          <template #prev-text>
            <feather-icon icon="ChevronLeftIcon" size="18" />
          </template>
          <template #next-text>
            <feather-icon icon="ChevronRightIcon" size="18" />
          </template>
        </b-pagination>
      </div>
    </div>

    <FieldSettingsModal :fields="fields" />
  </div>
</template>

<script>
import {
  BTable,
  BButton,
  BFormSelect,
  BPagination,
  BFormGroup,
  BRow,
  BCol,
  BFormTextarea,
  BOverlay,
} from 'bootstrap-vue'
import { mapActions, mapGetters } from 'vuex'
import VSelect from 'vue-select'
import formatters from '@/mixins/extra'
import VueDataPicker from '@/components/VueDatePicker.vue'
import { getUserData } from '@/auth/utils'
import FieldSettingsModal from '../modals/FieldSettingsModal.vue'
export default {
  components: {
    BTable,
    BButton,
    BFormSelect,
    BPagination,
    BFormGroup,
    BRow,
    BCol,
    VueDataPicker,
    VSelect,
    BFormTextarea,
    BOverlay,
    FieldSettingsModal,
  },
  mixins: [formatters],
  props: {
    // items: {
    //   type: Array,
    //   required: true,
    // },
    objectId: {
      type: Number,
      required: false,
    },
  },
  data() {
    return {
      amountSort: null,
      totalCount: 0,
      dateFromTo: null,
      params: {
        is_debt: '',
        manager_id: '',
        related_person: '',
        object_id: '',
        from_date: '',
        to_date: '',
        is_formed: '',
        page: 1,
        page_size: 100,
      },
      paramsManagers: {
        page: 1,
        page_size: 100,
      },
      filterTypeOptions: [
        { title: this.$i18n.t('reports.debts_exist'), id: true },
        { title: this.$i18n.t('reports.no_debts'), id: false },
      ],
      relatedPerson: [
        { ru: 'Ифтихор', uz: 'Iftixor' },
        { ru: 'Элбек', uz: 'Elbek' },
        { ru: 'Гиёс', uz: 'Giyos' },
        { ru: 'Шуҳрат', uz: 'Shuhrat' },
        { ru: 'Элёр', uz: 'Elyor' },
        { ru: 'Феруз', uz: 'Feruz' },
        { ru: 'Ходим', uz: 'Xodim' },
        { ru: 'Нет оплаты', uz: 'Tolanmagan' },
        { ru: 'Бартер', uz: 'Barter' },
        { ru: 'Прочие', uz: 'Boshqalar' },
      ],
      isNotFetched: false,
      fields: [
        {
          visible: true,
          key: 'index',
          label: '№',
        },
        {
          visible: true,
          key: 'client_fio',
          label: 'contract.investor_name',
          sortable: true,
          formatter(val) {
            return val !== 'total' ? val : ''
          },
        },
        {
          visible: true,
          key: 'client_phone_number',
          label: 'references.phone_number',
          formatter(val) {
            return `+${val}`
          },
        },

        {
          visible: true,
          key: 'contract_name',
          label: 'contract.contract_number',
        },
        {
          visible: true,
          key: 'total_price',
          label: 'contract.total_price',
        },
        {
          visible: true,
          key: 'created_date',
          label: 'contract.created_at',
        },
        {
          visible: true,
          key: 'payment_sum',
          label: 'reports.paid_amount',
        },
        {
          visible: false,
          key: 'monthly_price',
          label: 'contract.monthly_payment',
        },
        {
          visible: false,
          key: 'initial_fee',
          label: 'objects.initial_payment',
        },
        {
          visible: false,
          key: 'total_debt_sum_crm',
          label: 'debt_from_crm',
        },
        {
          visible: false,
          key: 'total_debt_sum_bank',
          label: 'debt_from_bank',
        },
        {
          visible: false,
          key: 'kv_m_price',
          label: 'kv_m_price',
        },
        {
          visible: false,
          key: 'monthly_count',
          label: 'how_many_months_need_to_pay',
        },
        {
          visible: false,
          key: 'total_area',
          label: 'total_area',
        },
        {
          visible: true,
          key: 'expired_payment',
          label: 'reports.unpaid_amount_installment',
          tdClass: 'text-danger',
          sortable: true,
        },
        {
          visible: true,
          key: 'total_debt_sum',
          label: 'reports.total_debt',
        },
        {
          visible: true,
          key: 'related_person',
          label: 'reports.related_person',
        },
        {
          visible: true,
          key: 'description',
          label: 'clients.comments',
        },
        {
          visible: true,
          key: 'actions',
          label: 'sms.actions',
          class: 'width-200',
        },
      ],
      initTimeout: null,
      items: [],
    }
  },
  computed: {
    ...mapGetters('objects', ['GET_OBJECTS']),
    ...mapGetters('clients', ['getUsers']),

    onFilter() {
      return [{ first_name: 'все', id: 'all' }].concat(this.getUsers.results)
    },
    getAllObjects() {
      return [{ title: 'все', id: 'all' }].concat(this.GET_OBJECTS)
    },
  },
  watch: {},
  async mounted() {
    await this.refresh()
    await this.FETCH_USERS_LIST({ ...this.paramsManagers, role: 6 })
  },
  methods: {
    ...mapActions('objects', ['FETCH_OBJECT_CONTRACTS_REPORT']),
    ...mapActions('clients', ['FETCH_USERS_LIST']),
    ...mapActions('objects', ['EXCEL_UPLOAD']),
    ...mapActions('contracts', ['UPDATE_ONE_CONTRACT']),

    checkCollector() {
      const userData = getUserData()
      return userData.permission.includes('collector')
    },

    async refresh(ordering) {
      this.isNotFetched = true
      if (this.dateFromTo && this.dateFromTo.start && this.dateFromTo.end) {
        this.params.from_date = this.dateFromTo.start
        this.params.to_date = this.dateFromTo.end
      } else {
        this.params.from_date = ''
        this.params.to_date = ''
      }

      const filters = {}

      if (this.params.manager_id == 'all') {
        filters.manager_id = ''
      }

      if (this.params.object_id == 'all') {
        filters.object_id = ''
      }

      await this.FETCH_OBJECT_CONTRACTS_REPORT({
        ...this.params,
        ...filters,
        ...ordering,
      }).then((res) => {
        this.items = res.data.results
        this.totalCount = res.data.count
      })
      this.isNotFetched = false
    },

    sorting(e) {
      if (e.sortBy === 'client_fio') {
        this.refresh({ name: e.sortDesc })
      } else if (e.sortBy === 'expired_payment') {
        this.refresh({ amount: e.sortDesc })
        this.amountSort = e.sortDesc
      }
    },
    exportExcel(id) {
      const filters = {}
      if (this.params.manager_id == 'all') {
        filters.manager_id = ''
      }

      if (this.params.object_id == 'all') {
        filters.object_id = ''
      }
      this.EXCEL_UPLOAD({
        ...id,
        ...this.params,
        ...filters,
        amount: this.amountSort,
      })
        .then((res) => {
          const url = window.URL.createObjectURL(new Blob([res.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'file.xlsx')
          document.body.appendChild(link)
          link.click()

          this.$nextTick(() => {
            this.$_successToast(this.$t('clients.file_uploaded_successfully'))
          })
        })
        .catch((err) => {
          console.log(err)
          this.$_errorToast(this.$t('generals.error'))
        })
        .finally(() => {
          this.loader = false
        })
    },

    changeRelatedPerson(event, id) {
      console.log(event, id)
      this.UPDATE_ONE_CONTRACT({ id, related_person: event?.uz || null })
        .then(() => {
          this.$_successToast(this.$t('generals.changed'))
        })
        .catch(() => {
          this.$_errorToast(this.$t('generals.error'))
        })
    },

    saveDescription(event, id) {
      clearTimeout(this.initTimeout)
      this.initTimeout = setTimeout(() => {
        this.UPDATE_ONE_CONTRACT({ id, description: event })
          .then(() => {
            this.$_successToast(this.$t('generals.changed'))
          })
          .catch(() => {
            this.$_errorToast(this.$t('generals.error'))
          })
      }, 1000)
    },

    async previousUsersGet() {
      if (this.getUsers.previous) {
        this.paramsManagers.page--
        await this.FETCH_USERS_LIST({ ...this.paramsManagers, role: 6 })
      }
    },

    async nextUsersGet() {
      if (this.getUsers.next) {
        this.paramsManagers.page++
        await this.FETCH_USERS_LIST({ ...this.paramsManagers, role: 6 })
      }
    },

    async changePagination(page) {
      this.params.page = page
      await this.refresh()
    },

    toggleFields(fields) {
      return fields.filter((el) => el.visible)
    },
  },
}
</script>

<style>
.dark-layout .pagination button {
  color: #fff !important;
  background-color: #3b4253 !important;
}

.pagination {
  display: flex;
  margin: 0.25rem 0.25rem 0;
}
.pagination button {
  flex-grow: 1;
  border: 1px solid #ccc;
}
.pagination button:hover {
  cursor: pointer;
}
</style>
